import { Link } from "react-router-dom";

export default function KesimPlanlamaPage() {
  return (
    <div className="min-h-screen bg-farm-cream font-body">
      <div className="max-w-4xl mx-auto px-3 sm:px-5 py-6 space-y-4">
        <div className="bg-white border border-farm-border rounded-farm p-5">
          <div className="flex items-start justify-between gap-3 flex-wrap">
            <div>
              <h1 className="font-heading font-bold text-base text-farm-brown">
                Kesim Planlama
              </h1>
              <p className="text-xs text-farm-muted mt-1 leading-5">
                Bu ekran artık pasif durumda tutuluyor.  
                Yeni akışta kesim operasyonu doğrudan
                <span className="font-semibold text-farm-brown"> Kesim Alanı</span>
                üzerinden yürür.
              </p>
            </div>

            <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-farm-border bg-farm-cream text-farm-muted text-xs font-semibold">
              <i className="ri-pause-circle-line text-sm" />
              Pasif Ekran
            </span>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-3">
          <div className="bg-white border border-farm-border rounded-farm p-4">
            <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-farm-earth-pale text-farm-earth mb-3">
              <i className="ri-checkbox-circle-line text-lg" />
            </div>
            <p className="text-sm font-semibold text-farm-brown">
              Kesime Uygun Tiki
            </p>
            <p className="text-xs text-farm-muted mt-1 leading-5">
              Hayvanlar sayfasında kesim işaretlemesi yapıldığında artık akış bu
              ekran yerine doğrudan Kesim Alanı’na düşer.
            </p>
          </div>

          <div className="bg-white border border-farm-border rounded-farm p-4">
            <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-farm-green-pale text-farm-green mb-3">
              <i className="ri-sort-asc text-lg" />
            </div>
            <p className="text-sm font-semibold text-farm-brown">
              Sıralama Kuralı
            </p>
            <p className="text-xs text-farm-muted mt-1 leading-5">
              Sıra Bekliyor listesi artık Küpe No’ya göre sıralanır. Başlatılan
              hayvan bekleyen sırasından çıkar ve öncelik düzenini bozmaz.
            </p>
          </div>

          <div className="bg-white border border-farm-border rounded-farm p-4">
            <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-farm-gold-pale text-farm-gold mb-3">
              <i className="ri-tv-2-line text-lg" />
            </div>
            <p className="text-sm font-semibold text-farm-brown">
              Operasyon Görünümü
            </p>
            <p className="text-xs text-farm-muted mt-1 leading-5">
              Canlı operasyon için Kesim Alanı ve TV ekranı kullanılır.
              Tamamlananlar ayrı kolonda birikir, TV ekranında görünmez.
            </p>
          </div>
        </div>

        <div className="bg-white border border-farm-border rounded-farm p-5">
          <div className="flex items-center justify-between gap-3 flex-wrap">
            <div>
              <p className="font-heading text-sm font-semibold text-farm-brown">
                Devam edilecek ekran
              </p>
              <p className="text-xs text-farm-muted mt-1">
                Operasyon takibini buradan değil, doğrudan Kesim Alanı ekranından sürdür.
              </p>
            </div>

            <Link
              to="/panel/kesim-alani"
              className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-farm-earth text-white text-sm font-semibold hover:bg-farm-brown transition-colors"
            >
              <i className="ri-scissors-2-line text-base" />
              Kesim Alanına Git
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}